import { createPublicApi, createTvClient, unwrap, type FetchLike } from '@/api/client';
import type { AudioClip, GameSession, PairedSpectator } from '@/api/types';

/** O que a TV (Espectador, ADR-0010) pede ao servidor: trocar o código por um token e ler a partida na visão pública. */
export interface TvApi {
  /** Troca o código mostrado ao anfitrião (com ou sem hífen, em qualquer caixa) por um token. `404 spectator.invalid_code` se não vale. */
  pair(code: string): Promise<PairedSpectator>;
  /** A partida desta TV na visão pública. `401` quer dizer que o pareamento acabou. */
  session(): Promise<GameSession>;
  /**
   * A música da vez para tocar na sala (jogos que tocam música, ADR-0011): o endereço temporário da prévia. `403 audio.not_available`
   * se não há música agora; `404 audio.no_preview` se a faixa não tem prévia.
   */
  audio(): Promise<AudioClip>;
}

export function createTvApi(options: {
  baseUrl: string;
  /** O token do pareamento atual (`null` antes de parear). */
  token: () => string | null;
  fetch?: FetchLike;
}): TvApi {
  // O pareamento é anônimo e nunca leva um token velho; a leitura leva o token da TV.
  const anonymous = createPublicApi(options.baseUrl, options.fetch);
  const reader = createTvClient(options.baseUrl, options.token, options.fetch);

  return {
    pair: (code) => unwrap(anonymous.POST('/api/v1/tv/pair', { body: { code } })),
    session: () => unwrap(reader.GET('/api/v1/tv/session')),
    audio: () => unwrap(reader.GET('/api/v1/tv/audio')),
  };
}
